import { Link } from 'react-router-dom';
import logo from '../assets/top.png'
const Footer = () => {
  return (
    <footer className="bg-[#0f172a] pt-24 pb-10 border-t border-white/5 relative overflow-hidden">
      
      {/* Background Decor (Subtle Glow) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#00F0FF]/5 blur-[100px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        
        {/* --- BIG CTA LINK --- */}
        {/* This replaces the form. It sends them to your new Contact Page. */}
        <div className="text-center mb-24">
            <h2 className="text-gray-500 font-mono text-sm tracking-[0.3em] uppercase mb-8">
                // System Status: Online
            </h2>
            
            <Link 
                to="/startProject" 
                className="group relative inline-block"
            >
                <h1 className="text-5xl md:text-8xl font-black font-display text-white transition-colors group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-[#00F0FF] group-hover:to-purple-500">
                    START A PROJECT
                </h1>
                {/* The "Underline" that expands */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-[#00F0FF] scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                
                {/* The Arrow Icon */}
                <div className="absolute -right-12 md:-right-20 top-1/2 -translate-y-1/2 opacity-0 -translate-x-10 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="#00F0FF" className="w-10 h-10 md:w-16 md:h-16">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                    </svg>
                </div>
            </Link>
        </div>

        {/* --- BOTTOM BAR --- */}
        <div className="border-t border-white/10 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
           
           {/* Logo */}
           <div className="text-xl font-bold tracking-tighter text-white">
              TOP <span className="text-[#00F0FF]">ORION</span>
           </div>

           {/* Navigation Links (Quick Access) */}
           <div className="flex gap-8 text-sm text-gray-400 font-bold uppercase tracking-widest">
              <Link to="/work" className="hover:text-white transition-colors">Work</Link>
              <Link to="/service" className="hover:text-white transition-colors">Services</Link>
              <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
           </div>

           {/* Socials & Copyright */}
           <div className="flex flex-col md:flex-row items-center gap-6 text-xs text-gray-600 font-mono">
              <div className="flex gap-4">
                  <a href="#" className="hover:text-[#00F0FF] transition-colors">GITHUB</a>
                  <a href="https://www.linkedin.com/in/toporionbd/" target='blank' className="hover:text-[#00F0FF] transition-colors">LINKEDIN</a>
                  <a href="https://x.com/toporionbd" target='blank' className="hover:text-[#00F0FF] transition-colors">TWITTER</a>
              </div>
              <span>© 2026 Top Orion Inc.</span>
           </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;